<template>
    <van-form>
        <van-field v-model="formData.info.company_name" :disabled="status === '0' || status === '1'" required label="公司名" placeholder="请输入公司名称" />
        <van-field v-model="formData.info.company_code" :disabled="status === '0' || status === '1'" required label="社会信用代码" placeholder="请输入统一社会信用代码" />
        <van-field v-model="formData.info.legal_person" :disabled="status === '0' || status === '1'" required label="法定代表人" placeholder="请输入法定代表人" />
        <div class="UploadContainer" v-if="!(status === '0' || status === '1')">
            <span class="UploadSpan">上传营业执照</span>
            <van-uploader v-model="image.check" :max-count="1" class="UploadImage" :after-read="imageAfterRead" :before-delete="cleanImage">
            </van-uploader>
        </div>
        <van-cell title="状态" v-if="status !== undefined && status !== ''">
            <van-tag size="large" :color="statusList.color[status]">{{$store.state.systemEnum.company.user_company_auth.status[status]}}</van-tag>
        </van-cell>
        <van-cell title="失败原因" v-if="status == 2" :value="cardInfo.failed_reason" />
        <van-cell title="管理油卡" is-link v-if="status === '1'" @click="cardList()"/>

        <div style="margin-top: 0.5rem;background: #fff" v-if="formData.info.business_license_img && id" >
            <span class="DispalySpan">预览</span>
            <van-image style="padding: 0.5rem;" :src="formData.info.business_license_img" @click="displayShow = true"/>
        </div>
        <div style="display: flex;justify-content: center;margin:0.6rem 0;" v-if="!(status === '0' || status === '1')">
            <van-button type="info" class="SubmitBtn" @click="save">提交</van-button>
        </div>

        <van-image-preview v-model="displayShow" :images="[formData.info.business_license_img]">
        </van-image-preview>
    </van-form>
</template>

<script>
    import api from "../../assets/js/api";
    import auth from "../../assets/js/auth";

    export default {
        name: "CompanyDetail",
        data(){
            return {
                isLoading: false,
                formData: {
                    info : {
                        company_name: '',
                        company_code: '',
                        legal_person: '',
                        business_license_img: ''
                    }
                },
                image: {
                    file: '',
                    check: []
                },
                id: '',
                status: '',
                cardInfo: '',
                statusList: {
                    color: ['#999', '#669944', '#aa4246']
                },
                displayShow: false
            };
        },
        created() {
            let self = this;
            if (this.$route.params.certifiactionCompanyId != 'null' && this.$route.params.certifiactionCompanyId) {
                this.isLoading = true;
                this.id = this.$route.params.certifiactionCompanyId;
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/user_company_auth/detail', {
                    'id' : this.id,
                }).then(res => {
                    self.formData.info = res.data.info;
                    self.status = res.data.status;
                    self.cardInfo = res.data;
                }).finally(() => {
                    self.isLoading = false;
                    self.$toast.clear(loading);
                })
            }
        },
        methods : {
            cardList() {
                this.$router.push({
                    name: 'CompanyCardList',
                    query: {user_company_auth_id: this.id}
                })
            },
            imageAfterRead(file) {
                this.image.file = file;
            },
            cleanImage() {
                this.image.file = '';
                this.image.check = [];
                this.formData.info.business_license_img = '';
            },
            save(){
                let self = this;
                if (this.image.check.length == 0 && !this.formData.info.business_license_img) {
                    self.$toast.fail('请上传对应图片');
                    return
                }
                if (this.isLoading) return;
                this.isLoading = true;
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                if (!this.formData.info.business_license_img) {
                    let fromData = new FormData();
                    fromData.append('file', self.image.file.file);
                    api.request('/common/image_upload', fromData).then(res => {
                        self.formData.info.business_license_img = res.data.file.url;
                        api.request('/user_company_auth/submit', self.formData).then(res => {
                            self.$toast(res.msg);
                            self.$router.back();
                            self.$toast.clear(loading);
                        }).catch(res => {
                            self.$toast.clear(loading);
                            self.$toast.fail(res.msg);
                        }).finally(() => {
                            self.isLoading = false;
                        });
                    }).catch(err => {
                        self.$toast.fail(err);
                    })
                } else {
                    api.request('/user_company_auth/submit', self.formData).then(res => {
                        self.$toast(res.msg);
                        self.$router.back();
                        self.$toast.clear(loading);
                    }).catch(res => {
                        self.$toast.clear(loading);
                        self.$toast.fail(res.msg);
                    }).finally(() => {
                        self.isLoading = false;
                    });
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .UploadContainer {
        background: #fff;
        display: flex;
        align-items: center;
        &::before {
            position: absolute;
            left: 0.21333rem;
            color: #ee0a24;
            font-size: 0.37333rem;
            content: '*';
        }
    }
    .UploadSpan {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        margin-left: 16px;
        width: 6.2em;
        margin-right: 0.32rem;
        color: #646566;
        text-align: left;
    }

    .UploadImage {
        padding-top: 10px;
    }

    .DispalySpan {
        text-align: center;
        display:block;
        font-size: 0.4rem;
        color: #666;
        padding: 0.4rem;
    }

    .SubmitBtn {
        margin: 0;
        width: 75vw;
        border-radius: 0.3rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/company/companyDetail.vue